import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyStudentAttemptQuestion = React.lazy(
	() => import(/* webpackChunkName: 'StudentAttemptQuestion' */ './components')
);

export default () => {
	return {
		path: 'question/:questionId',
		element: <AsyncLoading component={<LazyStudentAttemptQuestion />} />,
	};
};
